import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { scrollToForm } from '../utils/scrollToForm';
export function StickyCTA() {
  const [pastHero, setPastHero] = useState(false);
  const [formInView, setFormInView] = useState(false);
  const [footerInView, setFooterInView] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setPastHero(window.scrollY > window.innerHeight * 0.9);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Hide the bar while the form or footer is on screen so it never
  // covers the fields or buttons the person is trying to use.
  useEffect(() => {
    const form = document.getElementById('calificar');
    const footer = document.querySelector('footer');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === form) setFormInView(entry.isIntersecting);
        if (entry.target === footer) setFooterInView(entry.isIntersecting);
      });
    }, {
      threshold: 0.05
    });
    if (form) observer.observe(form);
    if (footer) observer.observe(footer);
    return () => observer.disconnect();
  }, []);
  const isVisible = pastHero && !formInView && !footerInView;
  return <AnimatePresence data-id="element-181" data-mp="1va7uk7fxxds">
      {isVisible && <motion.div initial={{
      y: 24,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 24,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="md:hidden fixed left-0 right-0 bottom-0 z-50 px-4 pt-3" style={{
      paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)'
    }} data-id="element-182" data-mp="3u0xnxzaqas9m">
          <a href="#calificar" onClick={scrollToForm} className="w-full flex items-center justify-center gap-2 bg-gold hover:bg-gold-light text-black font-semibold px-6 py-4 rounded-xl text-[15px] shadow-[0_10px_30px_rgba(0,0,0,0.6)] ring-1 ring-black/20 transition-colors duration-200" data-id="element-183" data-mp="clhnx1a7shvp">
            Solicitar mi diagnóstico gratuito
            <ArrowRight className="h-4 w-4" data-id="element-184" data-mp="vhzf9hl5ifrf" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}